import create from 'zustand';
import { persist } from 'zustand/middleware';

interface ArticleClickState {
  articleClicks: string[];
  addArticleClick: (articleId: string) => number;
  clearArticleClicks: () => void;
  clearSpecificArticleClicks: (articleId: string) => void;
}

export const useArticleClickStore = create<ArticleClickState>()(
  persist(
    (set, get) => ({
      articleClicks: [],
      
      addArticleClick: (articleId: string) => {
        set((state) => ({
          articleClicks: [...state.articleClicks, articleId]
        }));

        return get().articleClicks.length;
      },
      
      clearArticleClicks: () => {
        set({ articleClicks: [] });
      },
      
      clearSpecificArticleClicks: (articleId: string) => {
        set((state) => ({
          articleClicks: state.articleClicks.filter(id => id !== articleId)
        }));
      },
    }),
    {
      name: 'article-clicks-storage',
    }
  )
);
